let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jt6Nc")).then(() => parcelRequire('1nEI6'));